window.addEventListener("load", function () {
  function initLoadMoreAlumni() {
    const loadMoreBtn = document.getElementById("load-more-alumni");
    if (!loadMoreBtn) return;

    loadMoreBtn.addEventListener("click", function () {
      const hiddenBatch = document.querySelectorAll(".hidden-card.hidden");

      for (let i = 0; i < 4; i++) {
        if (hiddenBatch[i]) {
          hiddenBatch[i].classList.remove("hidden");
          window.dispatchEvent(new Event("resize"));
        }
      }

      if (document.querySelectorAll(".hidden-card.hidden").length === 0) {
        loadMoreBtn.style.display = "none";
      }
    });
  }

  initLoadMoreAlumni();
});
